(() => {
  const KEY = 'kleverQuoteCartV1';
  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items.filter(item => item && typeof item === 'object' && typeof item.title === 'string').slice(0,150).map(item => ({...item, quantity: Math.min(1000000, Math.max(1, Math.floor(Number(item.quantity) || 1))), unitPrice: Number.isFinite(Number(item.unitPrice)) ? Math.max(0, Number(item.unitPrice)) : 0})) : [];
    } catch (_) { return []; }
  };
  const write = items => {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateQuoteCount(items);
    window.dispatchEvent(new CustomEvent('klever:quote-cart-updated', { detail: items }));
  };
  const updateQuoteCount = (items = read()) => {
    const purchaseCount = Number(document.querySelector('[data-klever-purchase-count]')?.textContent || 0);
    const count = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0) + purchaseCount;
    document.querySelectorAll('[data-klever-quote-count]').forEach(el => el.textContent = count);
  };
  const addQuote = data => {
    const items = read();
    const id = String(data.id || data.url || data.title);
    const quantity = Math.min(1000000, Math.max(1, Math.floor(Number(data.quantity) || 1)));
    const unitPrice = Math.max(0, Number(data.unitPrice) || 0);
    const existing = items.find(item => String(item.id) === id);
    if (existing) {
      existing.quantity = Math.min(1000000, existing.quantity + quantity);
      if (unitPrice > 0) existing.unitPrice = unitPrice;
      existing.linePrice = (Number(existing.unitPrice) || 0) * existing.quantity;
    } else {
      items.push({ id, title:data.title, vendor:data.vendor || 'Klever Shop', sku:data.sku || '', image:data.image || '', url:data.url || '', quantity, unitPrice, linePrice:unitPrice * quantity });
    }
    write(items);
  };
  const showQuoteConfirmation = (title, saved = true) => {
    let dialog = document.querySelector('#KleverQuoteConfirmation');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'KleverQuoteConfirmation';
      dialog.className = 'kq-confirm';
      dialog.setAttribute('aria-labelledby', 'KleverQuoteConfirmationTitle');
      dialog.setAttribute('aria-describedby', 'KleverQuoteConfirmationMessage');
      dialog.innerHTML = `<div class="kq-confirm__body">
        <span class="kq-confirm__icon" aria-hidden="true">✓</span>
        <p class="kq-confirm__eyebrow">TU COTIZACIÓN</p>
        <h2 id="KleverQuoteConfirmationTitle"></h2>
        <p class="kq-confirm__product"></p>
        <p id="KleverQuoteConfirmationMessage"></p>
        <div class="kq-confirm__actions">
          <a class="kq-confirm__go">Ir a mi cotización <span aria-hidden="true">→</span></a>
          <button type="button" class="kq-confirm__dismiss" autofocus>Entendido, seguir explorando</button>
        </div>
      </div>`;
      dialog.querySelector('.kq-confirm__go').href = `${window.routes?.cart_url || '/cart'}?quote=1`;
      dialog.querySelector('.kq-confirm__dismiss').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => document.documentElement.classList.remove('kq-confirm-open'));
      document.body.append(dialog);
    }
    dialog.querySelector('#KleverQuoteConfirmationTitle').textContent = saved ? '¡Producto agregado a tu cotización!' : 'No pudimos guardar el producto';
    dialog.querySelector('.kq-confirm__product').textContent = title || '';
    dialog.querySelector('#KleverQuoteConfirmationMessage').textContent = saved
      ? 'Puedes seguir agregando productos. Cuando estés listo, entra a «Cotizar» en la parte superior de la página para revisar las cantidades y continuar tu solicitud por WhatsApp.'
      : 'Tu navegador no permitió guardar la selección. Intenta nuevamente y comprueba que permita el almacenamiento de este sitio.';
    dialog.querySelector('.kq-confirm__icon').textContent = saved ? '✓' : '!';
    dialog.querySelector('.kq-confirm__go').hidden = !saved;
    dialog.querySelector('.kq-confirm__dismiss').textContent = saved ? 'Entendido, seguir explorando' : 'Entendido';
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('kq-confirm-open');
  };
  const addPurchase = async button => {
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Agregando…';
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
      });
      if (!response.ok) throw new Error('No se pudo agregar');
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-klever-purchase-count],#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(el => el.textContent = cart.item_count);
      updateQuoteCount();
      button.textContent = 'Agregado al carro ✓';
      setTimeout(() => button.textContent = original, 1800);
    } catch (_) {
      button.textContent = 'Intenta nuevamente';
    } finally { button.disabled = false; }
  };
  const money = cents => new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format((Number(cents)||0)/100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const normalizePurchaseCart = cart => ({
    currency:cart.currency || 'CLP', total:cart.total_price || 0,
    items:(cart.items || []).map(item => ({title:item.product_title || item.title,variant:item.variant_title,vendor:item.vendor,sku:item.sku,key:item.key,image:item.image,url:item.url,quantity:item.quantity,unitPrice:item.final_price,linePrice:item.final_line_price}))
  });
  const hydrateStoredPrices = async () => {
    const items = read();
    const prices = new Map();
    let next = 0;
    await Promise.all(Array.from({length:Math.min(4,items.length)}, async () => {
      while (next < items.length) {
        const item=items[next++];
        const identity=String(item.id || item.url || item.title);
        prices.set(identity,{unitPrice:0,priceVisible:false});
        try {
          const productUrl=new URL(item.url,location.origin);
          if(productUrl.origin!==location.origin || !/^\/products\/[^/]+\/?$/.test(productUrl.pathname))continue;
          productUrl.search='';productUrl.hash='';productUrl.pathname=productUrl.pathname.replace(/\/$/,'')+'.js';
          const response=await fetch(productUrl,{signal:AbortSignal.timeout(5000)});
          if(!response.ok)continue;
          const product=await response.json();
          const tags=Array.isArray(product.tags)?product.tags.map(tag=>String(tag).toLowerCase()):[];
          const hidden=tags.includes('portal-price-hidden');
          const explicit=tags.includes('portal-price-visible');
          const legacyHidden=tags.some(tag=>['cotizar','por-cotizar','quote-only'].includes(tag));
          const variant=(product.variants||[]).find(candidate=>candidate.available)||product.variants?.[0];
          const price=Number(variant?.price);
          const visible=false;
          prices.set(identity,{unitPrice:visible&&Number.isFinite(price)?Math.max(0,price):0,priceVisible:visible});
        } catch (_) {}
      }
    }));
    // Read again so delayed responses never resurrect removals or overwrite changed quantities.
    const current=read().map(item=>{const price=prices.get(String(item.id||item.url||item.title));return price?{...item,...price,linePrice:price.unitPrice*item.quantity}:item;});
    if(prices.size)write(current);
    return prices.size>0;
  };
  const updatePurchaseLine = async (key, quantity) => {
    const response = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});
    if (!response.ok) throw new Error('No se pudo actualizar el carro');
    const cart = await response.json();
    window.kleverPurchaseCart = normalizePurchaseCart(cart);
    document.querySelectorAll('[data-klever-purchase-count],#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(el => el.textContent = cart.item_count);
    updateQuoteCount();
  };
  const renderQuotePage = () => {
    if (!new URL(location.href).searchParams.has('quote')) return;
    const page = document.querySelector('#KleverQuoteCartPage');
    if (!page) return;
    document.documentElement.classList.add('klever-quote-mode');
    document.querySelector('.main-cart .page-title')?.replaceChildren(document.createTextNode('Cotizar'));
    document.querySelector('.main-cart__wrapper cart-items')?.setAttribute('hidden','');
    document.querySelector('#main-cart-footer')?.setAttribute('hidden','');
    document.querySelector('#main-cart-shipping')?.setAttribute('hidden','');
    page.hidden = false;
    const builder = document.querySelector('.kq-builder');
    if (builder) builder.hidden = false;
    const render = () => {
      const quoteItems = read().map((item,index) => {
        const unitPrice = Math.max(0, Number(item.unitPrice) || 0);
        const quantity = Math.max(1, Number(item.quantity) || 1);
        return {...item,source:'quote',localIndex:index,quantity,unitPrice,linePrice:unitPrice * quantity};
      });
      const purchaseItems = (window.kleverPurchaseCart?.items || []).map(item => ({...item,source:'purchase'}));
      const items = [...quoteItems,...purchaseItems];
      const list = page.querySelector('[data-klever-quote-list]');
      page.querySelector('[data-klever-quote-empty]').hidden = items.length > 0;
      list.hidden = items.length === 0;
      list.innerHTML = items.map(item => {
        const pending = true;
        const badge = pending ? '<span class="kq-cart-item__badge kq-cart-item__badge--pending">Precio por confirmar</span>' : '<span class="kq-cart-item__badge kq-cart-item__badge--published">Precio publicado</span>';
        const price = pending ? '<div class="kq-cart-item__price"><span>Precio</span><strong>Por confirmar</strong></div>' : `<div class="kq-cart-item__price"><span>Precio unitario neto</span><strong>${money(item.unitPrice)} <i>+ IVA</i></strong><small>Total neto ${money(item.linePrice)}</small></div>`;
        const controls = `<div class="kq-cart-item__quantity"><button type="button" data-quote-minus aria-label="Disminuir cantidad">−</button><b>${item.quantity}</b><button type="button" data-quote-plus aria-label="Aumentar cantidad">+</button><button type="button" class="kq-cart-item__remove" data-quote-remove aria-label="Quitar producto" title="Quitar producto"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5"/></svg></button></div>`;
        return `<article class="kq-cart-item ${pending?'kq-cart-item--pending':'kq-cart-item--published'}" data-source="${item.source}" ${item.source === 'quote'?`data-index="${item.localIndex}"`:`data-key="${escapeHtml(item.key)}"`}>${item.image?`<img src="${escapeHtml(item.image)}" alt="">`:'<span class="kq-cart-item__placeholder">Sin imagen</span>'}<div><div class="kq-cart-item__meta"><small>${escapeHtml(item.vendor||'')}</small>${badge}</div><strong>${escapeHtml(item.title)}</strong><span>${item.sku?`Código: ${escapeHtml(item.sku)}`:'Código por confirmar'}</span></div>${price}${controls}</article>`;
      }).join('');
      const knownTotal = items.reduce((sum,item)=>sum+Number(item.linePrice||0),0);
      window.kleverQuoteCart = {currency:window.kleverPurchaseCart?.currency || 'CLP',total:knownTotal,items};
      const hasPrice = () => false;
      const pricedCount = items.filter(hasPrice).reduce((sum,item)=>sum+item.quantity,0);
      const pendingCount = items.filter(item => !hasPrice(item)).reduce((sum,item)=>sum+item.quantity,0);
      page.querySelector('[data-klever-quote-total]').textContent = `${pricedCount} con precio · ${pendingCount} por confirmar`;
    };
    page.addEventListener('click', async event => {
      const row = event.target.closest('.kq-cart-item'); if (!row) return;
      const plus = event.target.closest('[data-quote-plus]'), minus = event.target.closest('[data-quote-minus]'), remove = event.target.closest('[data-quote-remove]');
      if (!plus && !minus && !remove) return;
      if (row.dataset.source === 'quote') {
        const items = read(), index = Number(row.dataset.index);
        if (!Number.isInteger(index) || !items[index]) return;
        if (plus) items[index].quantity = Math.min(1000000,items[index].quantity+1);
        if (minus) items[index].quantity = Math.max(1,items[index].quantity-1);
        if (remove) items.splice(index,1);
        write(items); render(); return;
      }
      const purchaseItem = window.kleverPurchaseCart.items.find(item => item.key === row.dataset.key);
      if (!purchaseItem) return;
      const nextQuantity = remove ? 0 : plus ? purchaseItem.quantity + 1 : Math.max(1,purchaseItem.quantity - 1);
      row.classList.add('is-updating');
      try { await updatePurchaseLine(purchaseItem.key,nextQuantity); render(); }
      catch (_) { row.classList.remove('is-updating'); }
    });
    write(read().map(item=>({...item,unitPrice:0,linePrice:0,priceVisible:false})));
    render();
    hydrateStoredPrices().then(changed => { if (changed) render(); });
  };
  document.addEventListener('click', event => {
    const quoteButton = event.target.closest('[data-klever-quote-add]');
    if (quoteButton) {
      event.preventDefault();
      const quantityInput = quoteButton.closest('.product__buy-buttons')?.querySelector('[data-klever-quote-quantity]');
      try {
        addQuote({id:quoteButton.dataset.productId,title:quoteButton.dataset.title,vendor:quoteButton.dataset.vendor,sku:quoteButton.dataset.sku,image:quoteButton.dataset.image,url:quoteButton.dataset.url,quantity:quantityInput?.value || 1,unitPrice:quoteButton.dataset.unitPrice || 0});
      } catch (_) { showQuoteConfirmation(quoteButton.dataset.title, false); return; }
      showQuoteConfirmation(quoteButton.dataset.title);
      const original=quoteButton.textContent; quoteButton.textContent='Agregado a Cotizar ✓'; setTimeout(()=>quoteButton.textContent=original,1800);
    }
    const purchaseButton = event.target.closest('[data-klever-cart-add]');
    if (purchaseButton) { event.preventDefault(); addPurchase(purchaseButton); }
  });
  document.addEventListener('DOMContentLoaded', () => { updateQuoteCount(); renderQuotePage(); });
  window.KleverQuoteCart = {read,write,add:addQuote,refreshPrices:hydrateStoredPrices};
})();
